import Route from '@ember/routing/route';

export default class HotelOverviewSettingsRoute extends Route {}
